'use client'

import { useIsAuthenticated } from '@/lib/auth/client/AuthProvider.client'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { ButtonSkeleton } from '@/ui/skeleton/ButtonSkeleton.client'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function ProductCardSkeleton(): React.ReactElement {
  const isAuthenticated = useIsAuthenticated()

  return (
    <div className="relative flex min-h-[26rem] flex-col rounded-sm bg-white p-2 desktop:max-w-[20rem]">
      <BaseSkeleton className="mx-auto mt-2 size-17" />
      <div className="mt-2 flex flex-col gap-0.5">
        <TextSkeleton className="w-6" size="md" leading="normal" />
        <TextSkeleton className="w-10" size="lg" leading="normal" />
      </div>
      <div className="mt-auto flex flex-col">
        <TextSkeleton className="w-13" size="md" leading="normal" />
        <TextSkeleton className="mt-0.5 w-17" size="lg" leading="normal" />
        <ButtonSkeleton className="mt-1" size="lg" isRound={false} />
      </div>
      {isAuthenticated && <ButtonSkeleton className="absolute right-2 top-2" size="sm" isRound />}
    </div>
  )
}
